import React, { useState, useCallback } from 'react';
import axios from 'axios';
import { debounce } from 'lodash';
import './search-bar.css';
import SearchResult from './SearchResults'

export default function SearchBar ({clickedAddNewBusOrTrain}) {
  const [query, setQuery] = useState(''); // State to store user input
  const [results, setResults] = useState([]); // State to store API results
  const [loading, setLoading] = useState(false); // State to manage loading indicator

  // Function to fetch data from your API
  const fetchStops = async (searchTerm) => {
    if (!searchTerm) {
      setResults([]); // Clear results if search term is empty
      return;
    }

    setLoading(true); // Set loading state

    try {
      const response = await axios.get(process.env.REACT_APP_ENVIRONMENT + '/api/routes?search=' + searchTerm);
      setResults(response.data.routes); // Update the results with the API response
      //console.log(response.data.routes);
    } catch (error) {
      console.error('Error fetching stops:', error);
    } finally {
      setLoading(false); // Turn off loading state
    }
  };

  // Memoized debounced function to avoid excessive API calls
  const debouncedFetchStops = useCallback(
    debounce((searchTerm) => {
      fetchStops(searchTerm);
    }, 300),
    [] // Empty dependency array ensures this is only created once
  );

  // Handle input change and trigger debounced API call
  const handleChange = (e) => {
    const value = e.target.value;
    setQuery(value); // Update the input query

    // Trigger the debounced API call with the current input
    debouncedFetchStops(value);
  };

  return (
    <div className='search-bar-outer-container'>
      <div className="search-bar-container">
        <input
          id="search-bar-input"
          className='search-bar-input'
          type="text"
          placeholder="Search for bus or train..."
          value={query}
          onChange={handleChange}
        />

        {/* {loading && <p>Loading...</p>} */}

        <SearchResult results={results} loading={loading} clickedAddNewBusOrTrain={clickedAddNewBusOrTrain}/>
      </div>
    </div>
  );
};
